import type { InputBubbleProps } from '../../../InputBubble';
import type { OutsideClickExclusion } from '@/hooks';

// TODO: There are likely better solutions to how I've typed this.

export const SocialNetwork = {
    Discord: 'discord',
    Facebook: 'facebook',
    Instagram: 'instagram',
    LinkedIn: 'linkedin',
    TikTok: 'tiktok',
    Twitch: 'twitch',
    Twitter: 'twitter',
    YouTube: 'youtube',
} as const;

export const socialNetworkIds = Object.values(SocialNetwork);

export type SocialNetworkKeys = keyof typeof SocialNetwork;
export type SupportedSocialNetworks = (typeof SocialNetwork)[SocialNetworkKeys];

export type SocialLinkType = 'custom' | SupportedSocialNetworks;

interface BaseSocialItem {
    id: string;
    url: string;
    order: number;

    // TODO: It is possible each item needs the following:
    // sorting?: boolean;
    // placeholder?: string;
    // label?: string;

    // TODO: Should each item have its own `on*` action props?
}

interface CustomItemSubset {
    type: 'custom';
    handle?: never;
}

interface SocialItemSubset {
    type: SupportedSocialNetworks;
    handle: string;
}

export type SocialItemDescriptor = BaseSocialItem & (CustomItemSubset | SocialItemSubset);
export type SocialItems = SocialItemDescriptor[];

export interface CustomTypedItem extends BaseSocialItem, Pick<CustomItemSubset, 'type'> {}
export interface SocialTypedItem extends BaseSocialItem, Pick<SocialItemSubset, 'type' | 'handle'> {}

export interface SocialItemStateCriteria extends Pick<SocialItemDescriptor, 'id' | 'type' | 'handle'> {
    error?: boolean;
    editMode?: boolean;
    activeItem?: SocialItemDescriptor;
}

export interface SocialItemState {
    error: boolean;
    disabled: boolean;
    pressed: boolean;
}

export interface CommonSocialActions {
    onCancel(): void;
    onDelete(itemToDelete: SocialItemDescriptor): void;
    onChange: InputBubbleProps['onChange'];
    onSubmit(itemToSubmit: SocialItemDescriptor): void;
}

export interface CommonSocialInputProps extends CommonSocialActions {
    activeItem: SocialItemDescriptor;
    error?: boolean;
    // TODO: Try to avoid these `disable*` props.
    disableDelete?: boolean;
    disableSubmit?: boolean;
    cancelExclusions?: OutsideClickExclusion;
}
